import React from "react";
import { FaCheck } from "react-icons/fa";

const ActivateUser = ({ closeActivateUser, handleActivate, selectedUser }) => {
  const confirmActivate = () => {
    if (handleActivate && selectedUser?.id) {
      handleActivate(selectedUser.id);
    } else {
      console.error("Activate function or user ID is undefined");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center">
          Confirmer l'activation
        </h2>

        <p className="text-gray-600 mb-6">
          Voulez-vous vraiment réactiver{" "}
          <span className="font-semibold text-[#5E17EB]">
            {selectedUser?.name || "cet utilisateur"}
          </span>{" "}
          ? Il pourra à nouveau se connecter.
        </p>

        <div className="flex justify-end space-x-4">
          {/* Annuler */}
          <button
            type="button"
            onClick={() => closeActivateUser(false)}
            className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition duration-200"
          >
            Annuler
          </button>

          {/* Activer */}
          <button
            type="button"
            onClick={confirmActivate}
            className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition duration-200 flex items-center gap-2"
          >
            <FaCheck /> Activer
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActivateUser;